export default {
  dev: {
    host: "https://uomsit.midea.com/uom-4a/midea-uom-gateway/uom-server/",
    mapHost: 'https://mapnew5sit.midea.com/',
    _4aPCUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    '_problem-zh': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapnew5sit.midea.com/appdownload/pcv5.html'
  },
  sit: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
    mapHost: 'https://mapisit.midea.com/mtp/umeet/',
    _4aPCUrl: 'https://mapeconsolesit.midea.com/appdownload/pcv5-4a.html', // 测试
    _feedback: 'https://mapeconsolesit.midea.com/feedback/index.html', //意见反馈
    '_problem-zh': 'https://guide.midea.com/helpCenter/deta il?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signinuat.midea.com/login?service=',   // 测试
    defaultMobileUrl: 'https://mapeconsolesit.midea.com/appdownload/pcv5.html',

  },
  uat: {
    host: "https://uomsit.midea.com/midea-uom-gateway/uom-server/",
  },
  prod: {
    host: "https://uom.midea.com/midea-uom-gateway/uom-server/",
    mapHost: 'https://mapi.midea.com/mtp/umeet/',
    _4aPCUrl: 'https://im.midea.com/download/pcv5-4a.html',  // 生产
    _feedback: 'https://mapnew5.midea.com/feedback/index.html', //意见反馈(生产环境)
    '_problem-zh': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=zh', // 常见问题
    '_problem-en': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    '_problem-ja': 'https://guide.midea.com/helpCenter/detail?id=a1a7833b-ada0-48d8-87d5-0d1841368358&origin=T-MC&type=option&lang=en', // 常见问题
    _4aUrl: 'https://signin.midea.com/login?service=',
    defaultMobileUrl: 'https://im.midea.com/download/pcv5.html',
  },
  apis: [
    {
      // PC端获取下载地址
      name: "getPcUrl",
      config: {
        url: "api/sysParam/list/new/MeiXin_downloadPage_Link",
        // url: "api/sysParam/list/MeiXin_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "getMobileUrl",
      config: {
        url: "api/sysParam/listPost/MeiXin_downloadPage_Link",
        method: "post",
      },
    },
    {
      name: "getVPNUrl",
      config: {
        url: "api/sysParam/list/new/VPN_downloadPage_Link",
        method: "get",
      },
    },
    {
      name: "getMxVPNUrl",
      config: {
        url: "api/sysParam/list/VPN_downloadPage_Link",
        method: "get",
      },
    },
  ]
};